import { render, staticRenderFns } from "./assign.vue?vue&type=template&id=3e7c7a2f&scoped=true&"
import script from "./assign.vue?vue&type=script&lang=js&"
export * from "./assign.vue?vue&type=script&lang=js&"
import style0 from "./assign.vue?vue&type=style&index=0&id=3e7c7a2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7c7a2f",
  null
  
)

export default component.exports